import React from 'react';

import DemoUsersFilters from './filters/DemoUsersFilters';
import DemoUsersTable from './table/DemoUsersTable';

function DemoUsers() {
  return (
    <>
      <DemoUsersFilters />

      <DemoUsersTable />
    </>
  );
}

export default DemoUsers;
